/* eslint-disable import/no-anonymous-default-export */
import React from "react";

// import "./ViewInterviewVideos.scss";
import { Container, Spinner } from "react-bootstrap";
import Header from "../../Common/Header";
import useViewInterviewVideos from "./useAssignedAssessmentKits";
import "./AssignedAssessmentKits.scss";
import { dateFormatter } from "../../../_helpers/dateFormatter";
import { Progress, Space, Tooltip } from "antd";
import MainLayout from "../../Common/MainLayout";
export default (props) => {
  const {
    loading,
    assignedAssessmentKitsList,
    assignedAssessmentKitsListData,
    setLastElement,
    onAcceptInterviewClick,
    countTime,
    countQuestions,
  } = useViewInterviewVideos(props);
  return (
    <MainLayout pageName={"Assigned Assessment Kits"}>
      <div className="container list assigned-kits-wrapper">
        <div className="d-flex align-items-center">
          <p className="mr-3 text-nowrap font-weight-semi text-uppercase">
            Assigned Assessment KitS
          </p>
          <span className="border-bottom mb-2" style={{ width: "92%" }}></span>
        </div>
        {loading ? (
          <div className="d-flex justify-content-center align-items-center pt-5">
            <Spinner animation="border" variant="primary" />
          </div>
        ) : (
          <div className="row">
            {assignedAssessmentKitsList &&
              Array.isArray(assignedAssessmentKitsList) &&
              assignedAssessmentKitsList.map((item) => (
                <div className="col-md-6 col-lg-6" ref={setLastElement}>
                  <div className="my-3 border-radius-10 border shadow-sm p-3 rounded-lg assigned-kit-box">
                    <div className="d-flex content-header justify-content-between">
                      <div className="company-icon d-flex">
                        <Tooltip
                          title={`${
                            item?.answered_ques_count
                          } answered  / ${countQuestions(
                            item?.details &&
                              item.details?.interview_kit_detail &&
                              item.details.interview_kit_detail?.topics
                          )} total`}
                          getPopupContainer={(trigger) => trigger.parentNode}
                        >
                          <Progress
                            percent={Math.floor(
                              (item?.answered_ques_count /
                                countQuestions(
                                  item?.details &&
                                    item.details?.interview_kit_detail &&
                                    item.details.interview_kit_detail?.topics
                                )) *
                                100
                            )}
                            success={{ percent: 30 }}
                            type="circle"
                            size="small"
                          />
                        </Tooltip>
                        <div className="top-content d-flex justify-content-between align-items-center ml-4">
                          <h3 className="font-weight-bold mb-1 text-primary">
                            {item?.details &&
                              item.details?.interview_kit_detail &&
                              item.interview_kit_detail?.title}
                          </h3>
                          {/* <p className="text-grey-4">
                          {item?.details && item.details?.job_posting_details?.posted_by_details?.company_details?.name}
                        </p> */}
                        </div>
                      </div>
                    </div>
                    <div className="body-content py-3">
                      <div className="row mx-n1">
                        <div className="col-6 px-1">
                          <p className="font-weight-medium mb-2">
                            Total Topics:
                            <span className="text-grey-4 ml-2 font-weight-normal">
                              {Array.isArray(
                                item?.details &&
                                  item.details?.interview_kit_detail &&
                                  item.details.interview_kit_detail?.topics &&
                                  item.details.interview_kit_detail.topics
                              ) &&
                                item?.details &&
                                item.details?.interview_kit_detail &&
                                item.details.interview_kit_detail?.topics &&
                                item.details.interview_kit_detail.topics.length}
                            </span>
                          </p>
                        </div>

                        <div className="col-6 px-1">
                          <p className="font-weight-medium mb-2">
                            Answered Questions:
                            <span className="text-grey-4 ml-2 font-weight-normal">
                              {item?.answered_ques_count}
                            </span>
                          </p>
                        </div>

                        <div className="col-6 px-1">
                          <p className="font-weight-medium mb-2">
                            Total Questions:
                            <span className="text-grey-4 ml-2 font-weight-normal">
                              {countQuestions(
                                item?.details &&
                                  item.details?.interview_kit_detail &&
                                  item.details.interview_kit_detail?.topics
                              )}
                            </span>
                          </p>
                        </div>
                        <div className="col-6 px-1">
                          <p className="font-weight-medium mb-2">
                            Estimated Time:
                            <span className="text-grey-4 ml-2 font-weight-normal">
                              {countTime(
                                item?.details &&
                                  item.details?.interview_kit_detail &&
                                  item.details.interview_kit_detail?.topics
                              )}{" "}
                              Mins
                            </span>
                          </p>
                        </div>
                        <div className="col-6 px-1">
                          <p className="font-weight-medium mb-2">
                            Submit By:
                            <span className="text-grey-4 ml-2 font-weight-normal">
                              {dateFormatter(
                                item?.details &&
                                  item.details?.interview_kit_detail &&
                                  item.details.interview_kit_detail?.due_date
                              )}
                            </span>
                          </p>
                        </div>
                      </div>
                    </div>
                    <div className="action d-flex align-items-center border-top pt-3 justify-content-end">
                      {item?.is_accepted == null ||
                      item?.is_declined == null ? null : (
                        <button className="btn btn-light mr-4" disabled>
                          {item?.is_accepted
                            ? "Accepted"
                            : item?.is_declined
                            ? "Declined"
                            : null}
                        </button>
                      )}
                      <button
                        className="btn btn-primary"
                        onClick={() =>
                          onAcceptInterviewClick(
                            item?.details && item.details?.interview_kit,
                            item?.details && item.details?.job_posting
                          )
                        }
                      >
                        View Details
                      </button>
                    </div>
                  </div>
                </div>
              ))}
            <div className="col-12">
              <p className="text-center">
                Showing{" "}
                {Array.isArray(assignedAssessmentKitsList) &&
                  assignedAssessmentKitsList &&
                  assignedAssessmentKitsList.length}
                {/* of{" "}
                {assignedAssessmentKitsListData?.data &&
                  assignedAssessmentKitsListData.data?.count}{" "} */}{" "}
                Assessment kits.
              </p>
            </div>
          </div>
        )}
      </div>
    </MainLayout>
  );
};
